import * as React from "react";
import { resolveDiagramSvgHeight } from "../shared/diagramSvgDimensions";


import { CardiometabolicSugarMetabolismDiagramContent } from "./CardiometabolicSugarMetabolismDiagram";
import { CardiometabolicSugarMetabolismKeyContent } from "./CardiometabolicSugarMetabolismKey";

const SvgCardiometabolicSugarMetabolismDiagramKey = ({
  geneColors = {},
  expectedSnps = {},
  showKey = true,
  keyControlsId = "diagram-key",
  onGeneClick,
  width: widthProp,
  height: heightProp,
  ...props
}) => {
  const diagramOnly = !showKey;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
      width={widthProp ?? 1024}
      height={resolveDiagramSvgHeight(heightProp, diagramOnly, 1288, 1532)}
      viewBox={diagramOnly ? "0 170 1024 1288" : "0 0 1024 1532"}
    >
      <g id="cardiometabolic-sugarmetabolism-diagram+key" clipPath="url(#clip0_18306_241217)">
        <rect width={1024} height={diagramOnly ? 1288 : 1532} fill="white" />
        {showKey && (
          <g id={keyControlsId}>
            <CardiometabolicSugarMetabolismKeyContent />
          </g>
        )}
        <g transform={showKey ? `translate(0 74)` : undefined}>
          <CardiometabolicSugarMetabolismDiagramContent
            geneColors={geneColors}
            expectedSnps={expectedSnps}
            onGeneClick={onGeneClick}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_18306_241217">
          <rect width={1024} height={1532} fill="white" />
        </clipPath>
        <clipPath id="clip1_18306_241217">
          <rect width={1024} height={1288} fill="white" transform="translate(0 170)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgCardiometabolicSugarMetabolismDiagramKey;
